export { default, ManagerTableCellUserInfo } from './ManagerTableCellUserInfo';